// extracted by mini-css-extract-plugin
export default {"componentWrapper":"WisePagination_componentWrapper__wHD7x"};